export default "__VITE_ASSET__Lcns30DR__"